import React from 'react';
import { Link } from 'react-router-dom';
import { caseStudies } from '../../lib/caseStudiesData';

const projects = ['tracklytics', 'nba-cap-tracker', 'fieldstack', 'assad-j-legal-services']
  .map((slug) => caseStudies.find((project) => project.slug === slug))
  .filter(Boolean);

const imageClass = {
  // These two supplied project frames carry important branding at the edges.
  // Preserve their native proportions instead of turning them into a crop.
  tracklytics: 'h-auto object-contain bg-white',
  'nba-cap-tracker': 'aspect-[16/10] object-cover object-[43%_32%]',
  fieldstack: 'aspect-[16/10] object-cover object-[50%_25%]',
  'assad-j-legal-services': 'h-auto object-contain bg-white',
};

const layoutClass = {
  tracklytics: 'lg:col-span-7',
  'nba-cap-tracker': 'lg:col-span-5',
  fieldstack: 'lg:col-span-5',
  'assad-j-legal-services': 'lg:col-span-7',
};

const FeaturedWork = () => (
  <section className="bg-white px-6 py-20 lg:px-8 lg:py-28">
    <div className="mx-auto max-w-7xl">
      <div className="grid gap-8 border-b border-[#C9D7DD] pb-9 md:grid-cols-[1fr_auto] md:items-end">
        <div>
          <p className="text-sm font-semibold text-[#176B8A]">Selected work</p>
          <h2 className="mt-4 max-w-2xl text-4xl font-semibold leading-[1.04] tracking-[-.05em] text-[#102A3A] md:text-5xl">Built for the work, not a template.</h2>
        </div>
        <Link to="/case-studies" className="text-sm font-semibold text-[#176B8A]">View all work <span aria-hidden="true">&rarr;</span></Link>
      </div>

      <div className="mt-10 grid gap-x-7 gap-y-12 lg:grid-cols-12">
        {projects.map((project) => (
          <Link key={project.slug} to={`/case-studies/${project.slug}`} className={`group block ${layoutClass[project.slug]}`}>
            <div className="overflow-hidden rounded-[.55rem] border border-[#D3DFE4] bg-[#EDF2F3]">
              <img src={project.image} alt={`${project.name} website preview`} width="1200" height="760" loading="lazy" className={`w-full transition duration-700 ${imageClass[project.slug]}`} />
            </div>
            <div className="mt-4 flex items-start justify-between gap-5 border-t border-[#DCE4E8] pt-4">
              <div>
                <p className="text-xs font-semibold" style={{ color: project.accent }}>{project.category}</p>
                <h3 className="mt-2 text-xl font-semibold tracking-[-.03em] text-[#102A3A]">{project.name}</h3>
              </div>
              <span className="mt-1 shrink-0 text-lg text-[#176B8A] transition-transform duration-300 group-hover:translate-x-1" aria-hidden="true">&rarr;</span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  </section>
);

export default FeaturedWork;
